import { ButtonHTMLAttributes, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { LeoGlyph } from "@libs/zapi-ui/ds/components/leo-wordmark";
import { Tooltip, TooltipContent, TooltipTrigger } from "@libs/zapi-ui/ds/components/tooltip";

export function LeoLauncher({
  hasUnread = false,
  onClick,
  focusOnMount = false
}: {
  hasUnread?: boolean;
  onClick?: ButtonHTMLAttributes<HTMLButtonElement>["onClick"];
  focusOnMount?: boolean;
}) {
  const { t } = useTranslation("projectHome");
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (focusOnMount) buttonRef.current?.focus();
  }, [focusOnMount]);

  return (
    <div className="fixed end-5 bottom-5 z-40">
      <Tooltip>
        <TooltipTrigger
          render={
            <button
              ref={buttonRef}
              type="button"
              aria-label={t("leo.ask")}
              data-testid="chat-fab"
              onClick={onClick}
              className="relative flex size-14 items-center justify-center rounded-full bg-card text-leo shadow-lg ring-1 ring-foreground/10 transition-[scale,opacity] duration-300 outline-none hover:scale-105 focus-visible:ring-3 focus-visible:ring-ring/50 active:scale-95"
            />
          }
        >
          <LeoGlyph className="size-7" title="" />
          {hasUnread && <span className="absolute end-0.5 top-0.5 size-3 rounded-full bg-primary ring-2 ring-card" />}
        </TooltipTrigger>
        <TooltipContent side="left">{t("leo.ask")}</TooltipContent>
      </Tooltip>
    </div>
  );
}
